module.exports = __webpack_public_path__ + "static/flags/NU-4225dec9fc1bd8fcf86998281e418d8a.gif";